import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TEXT } from '@rsos/constants/locationTypes';
import { EmergencyCallSecondaryLocation } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCalls.types';
import { StateWithEmergencyCalls } from '@rsos/reduxDataStore/src/features/emergencyCalls/emergencyCallsSlice';
import { getMostRecentLoc } from '@rsos/utils/getMostRecentLoc';

/**
 * True only for the legacy Agent511 flag or an ALI class_of_service_category
 * of Text -- deliberately narrower than the broader isSMS-style signal used
 * elsewhere (e.g. RCS/admin_sms/citizen_location sources), since a false
 * positive here disables Start Chat rather than just gating a speculative
 * fetch.
 */
const useIsTT911Call = (callerID: string): boolean => {
  const call = useSelector(
    (state: StateWithEmergencyCalls) =>
      state.emergencyCalls.callQueue[callerID],
  );
  const mostRecentLocation = useMemo(() => getMostRecentLoc(call), [call]);

  return Boolean(
    call?.isTT911 ||
      (mostRecentLocation as EmergencyCallSecondaryLocation)
        ?.class_of_service_category === TEXT,
  );
};

export default useIsTT911Call;
